import type { Hotel, HotelExperience as Experience } from '~~/domains/graphql';

type HotelExperiences = {
  experiences: Experience[];
};

export function useHotelExperiences(
  hotel: Ref<Hotel | null | undefined>,
): ComputedRef<HotelExperiences> {
  return computed<HotelExperiences>(() => ({
    experiences: (hotel.value?.hotelExperiences ?? []) as Experience[],
  }));
}
